import { alpha, Chip, Grid, Paper, Tooltip, Typography, Box, Button, IconButton,Menu,MenuList, MenuItem, ListItemIcon, CircularProgress, Stack } from '@mui/material'
import React, { useState } from 'react'
import { formatDate, getMimeTypefromString, QuestionnaireStatus } from '../../../_helpers';
import { makeStyles, withStyles } from '@mui/styles';
import clsx from "clsx";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { CloudDownload, Edit, PictureAsPdf, Send, Visibility } from '@mui/icons-material';
import SelectResponsiblePerson from '../../Survey/components/SelectResponsiblePerson';
import { flushSync } from 'react-dom';
import { questionnaireSendEmail, questionnaireUpdateExecutor, questionnaireUpdateStatus } from '../../../apis/questionnaireApis';
import { questionnaireDetailActions } from '../../../_actions/questionnaireDetail.actions';
import { getBasicDataKeys } from './utils';
import { red } from '@mui/material/colors';
import PreviewAndComplete from './PreviewAndComplete';
import DocumentViewer from '../../../components/DocumentViewer';
import { URLS } from '../../../apis/urls';
import ConfirmBox from '../../../components/ConfirmBox';

const StyledMenuItem = withStyles((theme) => ({
  root: {
    whiteSpace: "pre-wrap",
    padding: theme.spacing(1, 0),
    "& div": {
      minWidth: 40,
      color: theme.palette.grey[700],
    },
    "& span": {
      color: theme.palette.grey[700],
      fontSize: 12,
    },
  },
}))(MenuItem);

const BasicQuestionnaireDetails = ({ validateAllSections,showPdfIcon }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const history = useHistory();
    const [anchorEl, setAnchorEl] = useState(null);
    const [organizationsLoading, setOrganizationsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [pdfMenuLoading, setPDFMenuLoading] = useState(false);
    const [openCompleteDialog,setOpenCompleteDialog] = useState(false)
    const [reportPopOverEl, setReportPopOverEl] = useState(null);
    const [isOpenDocViewer, setISOpenDocViewer] = useState(false);
    const [previewDocument, setPreviewDocument] = useState([]);
    const [openSkipConfirmModal, setOpenSkipConfirmModal] = useState(false);
    const { questionnaireStore: { questionnaireDetails: { questionnaireDetails } } } = useSelector(state => state);
    const { user } = useSelector((state) => state.authentication);

    const isProject = questionnaireDetails?.projectId && !questionnaireDetails?.buildingId;
    const normalizedDetails = { ...questionnaireDetails };
    const isCurrentUserExecutor = questionnaireDetails?.executorLoginId === user.id;
    const isQuestionnaireInProgress = questionnaireDetails?.status === QuestionnaireStatus.InProgress;
    const isCompleted = questionnaireDetails?.status === QuestionnaireStatus.Completed;
    const isSkipped = questionnaireDetails?.status === QuestionnaireStatus.Skip;
    const showActionButtons = !isCompleted && !isSkipped;
    const canStartQuestionnaire = !isQuestionnaireInProgress && isCurrentUserExecutor;
    const canPreviewQuestionnaire = isQuestionnaireInProgress && isCurrentUserExecutor;
    const questionnaireId = questionnaireDetails?.id;
    const keys = getBasicDataKeys(isProject);
    
    const handlePreviewWithValidation = () => {
        const { isValid, firstInvalidSectionIndex } = validateAllSections();

        if (!isValid) {
            dispatch(
                questionnaireDetailActions.changeSectionIndex(firstInvalidSectionIndex)
            );

            return;
        }
        previewHandler();
    };

    const previewHandler = () => {
        history.push(`/vragenlijst/${questionnaireId}/preview`);
    }

    const handleSendQuestionnaireEmail  = async (payload) => {
        await questionnaireSendEmail(questionnaireId, payload);
    };

    const handleUpdateStatusChange = async (newStatus) => {
        const payload = {
            questionnaireId: questionnaireId,
            status: newStatus,
            report: null
        };

        try {
            await questionnaireUpdateStatus(questionnaireId, payload);
            dispatch(questionnaireDetailActions.fetchQuestionnaireDetails(questionnaireId));
        } catch (err) {
            console.error(err);
        }
    };


    const pdfShowHandler = async () => {
        try {
            setPDFMenuLoading("view");
            setPreviewDocument([
                    {
                      uri:URLS.GET_QUESTIONNAIRE_REPORT + questionnaireId,
                      fileType: getMimeTypefromString(".pdf"),
                      name: isProject ?  questionnaireDetails?.projectName : questionnaireDetails?.buildingNoIntern,
                    },
                  ]);
            setISOpenDocViewer(true);
        } catch (error) {
            console.error("Error opening PDF:", error);
        } finally {
            setPDFMenuLoading(false);
        }
    };

    const handleUpdateExecutor = async (data) => {
        const loginId = data?.loginId;
        await questionnaireUpdateExecutor(loginId, [questionnaireId]);
        dispatch(questionnaireDetailActions.fetchQuestionnaireDetails(questionnaireId))
        setAnchorEl(null);
        setIsSubmitting(false)
    };

    return (
        <>
            <Box display={'flex'} justifyContent={'flex-end'} my={0.5}>
                {showActionButtons &&
                    (
                        <>
                        <Button
                            className={classes.signButton}
                            variant="contained"
                            color="primary"
                            disabled={!isCurrentUserExecutor}
                            onClick={() => setOpenSkipConfirmModal(true)}
                        >
                            {t('questionnaire.skip')}
                        </Button>
                        <Button
                            className={classes.signButton}
                            variant="contained"
                            color="primary"
                            disabled={!canPreviewQuestionnaire && !canStartQuestionnaire}
                            onClick={isQuestionnaireInProgress ? handlePreviewWithValidation : () => handleUpdateStatusChange(QuestionnaireStatus.InProgress)}
                            >
                            {isQuestionnaireInProgress ? t('general.previewAndComplete') : t('general.start')}
                        </Button>
                        </>
                    )
                }
            </Box>
            <div className={classes.detailMainHeader}>
                <Typography className={classes.detailHeader}>{t("general.basicData")}</Typography>
                <Stack direction={'row'} spacing={1} alignItems={'center'}><Typography variant='caption'>{t('questionnaire.numberOfQuestions')}: {questionnaireDetails?.noOfQuestions}</Typography>
                    {(showPdfIcon && isCompleted) && (
                        <IconButton onClick={(e) => setReportPopOverEl(e.currentTarget)} className={classes.signButton} variant="outlined" size="large">
                            <PictureAsPdf style={{ fill: red[800] }} />
                        </IconButton>
                    )}
                    <Chip label={t(`questionnaire.status.${questionnaireDetails?.status}`)} className={classes.detailChip} />
                </Stack>

            </div>

            <div className={classes.detailContainer}>
                <Grid container spacing={1} className={classes.detailsContain}>
                    {keys.map((group) => (
                        <Grid
                            className={classes.detailSubContainer}
                            size={{
                                xs: 6,
                                sm: 6,
                                md: 3,
                                lg: 3,
                                xl: 3,
                            }}
                        >
                            <Paper className={classes.detailPaper}>
                                {group.items.map((p) => {

                                    const openExecutorInfo = p.event === "hover" && !isCompleted;
                                    const cardProps = p.event === "hover" ? { "aria-haspopup": "true" } : {};
                                    const label = p?.title ? t(p.title) : "";
                                    const value =
                                        p.key === "createdOn" ? formatDate(new Date(normalizedDetails[p.key]), true, "-", true)
                                            : p.key === "status" ? t(`questionnaire.status.${normalizedDetails[p.key]}`)
                                                : normalizedDetails[p.key] ? t(normalizedDetails[p.key])
                                                    : "";

                                    return (
                                        <React.Fragment key={p.key || Math.random()}>
                                            <div className={classes.detailInnerPapper}>
                                                <Typography className={classes.detailText}>
                                                    {label ? `${label}:` : ""}
                                                </Typography>

                                                <div
                                                    className={clsx(
                                                        classes.detailSubItem,
                                                        openExecutorInfo && classes.dottedBottomBorder
                                                    )}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                    }}
                                                >
                                                    <Tooltip enterTouchDelay={0}>
                                                        <Typography
                                                            className={classes.detailSubText}
                                                            {...cardProps}
                                                            style={{
                                                                cursor:
                                                                    p.key === "executor" ? "pointer" : "default",
                                                                flex: 1,
                                                                marginRight: 8,
                                                            }}
                                                        >
                                                            {value || '-'}
                                                        </Typography>
                                                    </Tooltip>

                                                    {p.key === "executor" && (
                                                        <IconButton
                                                            size="small"
                                                            disabled={isCompleted || isSkipped}
                                                            onClick={(e) => {
                                                                if (isCompleted || isSkipped) return;
                                                                setAnchorEl(e.currentTarget);
                                                            }}
                                                        >
                                                            <Edit fontSize="small" />
                                                        </IconButton>
                                                    )}
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    );
                                })}
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
                {showPdfIcon && (
                    <Menu
                        id="simple-menu"
                        className={classes.menuContent}
                        anchorEl={reportPopOverEl}
                        open={!!reportPopOverEl}
                        onClose={() => setReportPopOverEl(null)}
                        keepMounted
                        elevation={1}
                        getContentAnchorEl={null}
                        disableRestoreFocus
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                        }}
                    >
                        <MenuList className={classes.menuListStyle}>
                            <StyledMenuItem disabled={pdfMenuLoading === "download"} component={"a"} href={URLS.GET_QUESTIONNAIRE_REPORT + questionnaireId} download >
                                <ListItemIcon>{pdfMenuLoading === "download" ? <CircularProgress size={18} style={{ minWidth: 0 }} color="primary" /> : <CloudDownload className={classes.menuIcon} color={"primary"} />}</ListItemIcon>
                                <Typography variant="inherit">{t("general.download")}</Typography>
                            </StyledMenuItem>
                            <StyledMenuItem disabled={pdfMenuLoading === "view"} onClick={pdfShowHandler}    >
                                <ListItemIcon>{pdfMenuLoading === "view" ? <CircularProgress size={18} style={{ minWidth: 0 }} color="primary" /> : <Visibility className={classes.menuIcon} color={"primary"} />}</ListItemIcon>
                                <Typography variant="inherit">{t("general.show")}</Typography>
                            </StyledMenuItem>
                            <StyledMenuItem onClick={() => { setOpenCompleteDialog(true) }} >
                                <ListItemIcon>
                                    <Send className={classes.menuIcon} color={"primary"} />
                                </ListItemIcon>
                                <Typography variant="inherit">{t("general.send")}</Typography>
                            </StyledMenuItem>


                        </MenuList>
                    </Menu>
                )}
                <PreviewAndComplete
                    open={openCompleteDialog}
                    closeModalHandler={() => setOpenCompleteDialog(false)}
                    onSend={handleSendQuestionnaireEmail }
                />
                <DocumentViewer
                    radius={classes.docRadius}
                    open={isOpenDocViewer}
                    onClose={() => {
                        setISOpenDocViewer(false)
                        setPreviewDocument([])
                    }}
                    documents={previewDocument}
                />
                <SelectResponsiblePerson
                    loading={organizationsLoading}
                    customTitle={t("general.responsible")}
                    isSubmitting={isSubmitting}
                    forQuestionnaireCreate
                    onSubmit={(data) => handleUpdateExecutor(data)}
                    setLoading={(val) => {
                        flushSync(() => {
                            setOrganizationsLoading(val);
                            setIsSubmitting(true);
                        });
                    }}
                    anchorEl={anchorEl}
                    onClose={() => {
                        setAnchorEl(null)
                    }} />
                <ConfirmBox
                    open={openSkipConfirmModal}
                    title={t("general.warning")}
                    description={t('questionnaire.skip.confirm.description')}
                    okText={t("general.confirm")}
                    cancelText={t("general.cancel")}
                    onOk={async () => {
                        await handleUpdateStatusChange(QuestionnaireStatus.Skip);
                        setOpenSkipConfirmModal(false);
                    }}
                    onCancel={() => setOpenSkipConfirmModal(false)}
                />

            </div>
        </>
    )
}

export default BasicQuestionnaireDetails
const useStyles = makeStyles((theme) => ({
    "@global": {
        ".MuiButtonBase-root:focus": {
            outline: 0,
        },
    },
    menuListStyle: {
        padding: theme.spacing(1.875, 1.25),
        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
        borderRadius: 10,
        width: 167,
    },
    menuIcon: {
        marginRight: 10,
    },
    menuContent: {
        "& .MuiPopover-paper": {
            borderRadius: 10,
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px !important",
        },
        "& ul": {
            padding: theme.spacing(0),
        },
        "& ul > ul": {
            padding: theme.spacing(0.5, 2),
        },
    },
    detailSubItem: {
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        textOverflow: "ellipsis",
        "-webkitLineClamp": 1,
        "-webkitBoxOrient": "vertical",
    },
    detailsContain: {
        flexGrow: 1,
    },
    signButton: {
        fontSize: 12,
        [theme.breakpoints.only("xs")]: {
            fontSize: 14,
            padding: theme.spacing(0.2, 1.9),
        },
        [theme.breakpoints.only("sm")]: {
            fontSize: 16,
            padding: theme.spacing(0.2, 1.9),
        },
        fontWeight: "normal",
        marginLeft: 8,
        whiteSpace: "nowrap",
    },
    detailSubContainer: {
        [theme.breakpoints.down("sm")]: {
            padding: `5px !important`,
        },
    },
    detailChip: {
        height: 25,
        fontSize: 12,
        [theme.breakpoints.only("xs")]: {
            padding: theme.spacing(1.2, 1),
            fontSize: 14,
        },
        [theme.breakpoints.only("sm")]: {
            fontSize: 16,
        },
        padding: theme.spacing(0),
    },
    detailMainHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
       
      
        minHeight: 57,
    },
    detailText: {
        fontSize: 12,
        [theme.breakpoints.only("xs")]: {
            fontSize: 14,
        },
        [theme.breakpoints.only("sm")]: {
            fontSize: 16,
        },
        color: theme.palette.common.black,
        fontWeight: "bold",
        whiteSpace: "nowrap",
        paddingRight: theme.spacing(2),
    },
    detailSubText: {
        fontSize: 12,
        [theme.breakpoints.only("xs")]: {
            fontSize: 14,
        },
        [theme.breakpoints.only("sm")]: {
            fontSize: 16,
        },
        color: theme.palette.grey[600],
        wordBreak: "break-all",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        "-webkitLineClamp": 1,
        "-webkitBoxOrient": "vertical",
    },
    detailPaper: {
        height: 70,
        [theme.breakpoints.down("sm")]: {
            height: 110,
        },
        borderLeft: `2px solid ${theme.palette.primary.main}`,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        background: alpha(theme.palette.primary.main, 0.05),
        boxShadow: "none",
        padding: theme.spacing(1),
        display: "flex",
        flexDirection: "column",
    },
    detailInnerPapper: {
        position: "relative",
        display: "flex",
        justifyContent: "space-between",
        flexGrow: 1,
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start",
            height: "100%",
        },
    },
    detailContainer: {
       paddingBottom: theme.spacing(1.5),
    },
    detailHeader: {
        fontSize: 16,
        color: theme.palette.grey[800],
        fontWeight: "bold",
    },
    dottedBottomBorder: {
        borderBottom: `1px dotted ${theme.palette.grey[600]}`,
        cursor: "default",
    },
}));